module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-4.aca22ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-4.jpg
// module id = FC+E
// module chunks = 1